// @ts-nocheck
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import VideoVendorsTab from '@/components/admin/video/VideoVendorsTab';
import VideoAnalyticsTab from '@/components/admin/video/VideoAnalyticsTab';
import VideoFinanceTab from '@/components/admin/video/VideoFinanceTab';

const VideoVendorManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState('vendors');

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold">Video Vendor Management</h1>
        <p className="text-gray-600 mt-1">
          Manage video vendor accounts, commissions, and analytics
        </p>
      </div>

      {/* Main Content */}
      <Card>
        <CardHeader>
          <CardTitle>Video Vendor Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="vendors">Video Vendors</TabsTrigger>
              <TabsTrigger value="analytics">Analytics</TabsTrigger>
              <TabsTrigger value="finance">Finance</TabsTrigger>
            </TabsList>
            
            <TabsContent value="vendors" className="mt-6">
              <VideoVendorsTab />
            </TabsContent>
            
            <TabsContent value="analytics" className="mt-6">
              <VideoAnalyticsTab />
            </TabsContent>
            
            <TabsContent value="finance" className="mt-6">
              <VideoFinanceTab />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default VideoVendorManagement;